import { render, staticRenderFns } from "./EventNumber.vue?vue&type=template&id=1f277e68"
import script from "./EventNumber.vue?vue&type=script&lang=js"
export * from "./EventNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports